import { render, staticRenderFns } from "./map_setting.vue?vue&type=template&id=b901362c"
import script from "./map_setting.vue?vue&type=script&lang=js"
export * from "./map_setting.vue?vue&type=script&lang=js"
import style0 from "./map_setting.vue?vue&type=style&index=0&id=b901362c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b901362c')) {
      api.createRecord('b901362c', component.options)
    } else {
      api.reload('b901362c', component.options)
    }
    module.hot.accept("./map_setting.vue?vue&type=template&id=b901362c", function () {
      api.rerender('b901362c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/didi/rules/map_setting.vue"
export default component.exports